module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-laseroveho-resurfacingu_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/vyhlazeni-vrasek-metodou-laseroveho-resurfacingu_2_after.jpg
// module id = 1269
// module chunks = 0